import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { CREDIT_TYPE, FLOW_TYPE } from '../../../../framework/App/AppConstants';
import PopupLink from '../../../../shared-components/PopupLink/PopupLink';
import { TERMS_URL } from '../../../USConstants';
import _ from 'lodash';
import { connect } from 'react-redux';

const LOCALE_PREFIX = 'US/components/CTABanner/CTABanner';

export class DefaultCTABanner extends Component {

    static propTypes = {
        creditType: PropTypes.oneOf(Object.values(CREDIT_TYPE)).isRequired,
        financingDetails: PropTypes.shape({
            term: PropTypes.number
        }),
        name: PropTypes.string,
        flow: PropTypes.string,
        cartTotal: PropTypes.string,
        convertedCartTotal: PropTypes.string,
        isCrossCurrency: PropTypes.bool,
        mppInstallmentsTermsUrl: PropTypes.string,
        isBAWithoutPurchase: PropTypes.bool.isRequired,
        is3EZP: PropTypes.bool
    };

    getInstallmentsContent(cartTotal, financingDetails, mppInstallmentsTermsUrl) {
        // Check for 3mo INST cyco core offer.
        const is3EZP = _.get(financingDetails, 'term') === 3;

        const content = {
            bannerHeadline: (
                <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-inst`}
                    values={{
                        cartTotal
                    }}
                />
            ),
            bannerTaglineId: `${LOCALE_PREFIX}.cta-tagline-mobile-inst`,
            bannerPopupLinkTextId: `${LOCALE_PREFIX}.cta-tagline-mobile-inst-link-text`
        };

        if (is3EZP) {
            content.bannerHeadline = (
                <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-inst-3ezp`}
                    values={{
                        apr: _.toNumber(_.get(financingDetails, 'apr')),
                        monthlyPayment: _.get(financingDetails, 'monthly_payment'),
                        numMonths: _.get(financingDetails, 'term')
                    }}
                />
            );
            content.bannerTaglineId = `${LOCALE_PREFIX}.cta-tagline-mobile-inst-3ezp`;
            content.bannerPopupLinkTextId = `${LOCALE_PREFIX}.cta-tagline-mobile-inst-link-text-3ezp`;
        }

        return (
            <div className="cta-banner cta-banner--ni show-for-mobile">
                <div className="cta-headline">
                    {content.bannerHeadline}
                </div>
                <div className="cta-tagline">
                    <FormattedHTMLMessage id={content.bannerTaglineId}
                        values={{
                            termsLinkClass: 'cta-tagline-link'
                        }}
                    />
                    &nbsp;
                    <PopupLink url={mppInstallmentsTermsUrl} className="cta-tagline-link">
                        <FormattedMessage id={content.bannerPopupLinkTextId} />
                    </PopupLink>
                </div>
            </div>
        );
    }

    render() {
        const { 
            creditType, 
            financingDetails, 
            name, 
            flow, 
            cartTotal, 
            convertedCartTotal, 
            mppInstallmentsTermsUrl, 
            isCrossCurrency, 
            isBAWithoutPurchase 
        } = this.props;

        let creditLineBanner = null;
        const greeting = name ? (
            <FormattedMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-greeting-name`} values={{ name }} />
        ) : (
            <FormattedMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-greeting`} />
        );
        const baPostFix = isBAWithoutPurchase ? '-billing-agreement' : '';


        switch (creditType) {
            case CREDIT_TYPE.INSTALLMENTS:
                creditLineBanner = this.getInstallmentsContent(cartTotal, financingDetails, mppInstallmentsTermsUrl);
                break;
            case CREDIT_TYPE.NO_INTEREST:
                creditLineBanner = (
                    <div className="cta-banner cta-banner--ni show-for-mobile">
                        <div className="cta-headline">
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-ni`}
                                values={{
                                    numMonths: _.get(financingDetails, 'term'),
                                    cartTotal: isCrossCurrency ? convertedCartTotal : cartTotal
                                }}
                            />
                        </div>
                        <div className="cta-tagline">
                            <FormattedMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-ni`} />
                            &nbsp;
                            <PopupLink url={TERMS_URL} className="cta-tagline-link">
                                <FormattedMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-ni-link-text`} />
                            </PopupLink>
                        </div>
                    </div>
                );

                break;
            case CREDIT_TYPE.CORE:
                creditLineBanner = (
                    <div className="cta-banner cta-banner--core show-for-mobile">
                        <div className="cta-headline">
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-headline-mobile-core${baPostFix}`}
                                values={{
                                    cartTotal: isCrossCurrency ? convertedCartTotal : cartTotal
                                }}
                            />
                        </div>
                        <div className="cta-tagline">
                            <FormattedMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-core`} />
                            &nbsp;
                            <PopupLink url={TERMS_URL} className="cta-tagline-link">
                                <FormattedMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-core-link-text`} />
                            </PopupLink>
                        </div>
                    </div>
                );
                break;
            default:
                creditLineBanner = (
                    <div className="cta-banner show-for-mobile">
                        <div className="cta-headline">
                            <span className="cta-name">
                                {greeting}
                            </span>
                        </div>
                        <div className="cta-tagline">
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-greeting`} />
                        </div>
                    </div>
                );
        }

        return (
            <div className="DefaultCTABanner">
                {creditLineBanner}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    cartTotal: _.get(state, 'serverData.cart.gross_total_amount.value'),
    convertedCartTotal: _.get(state, 'serverData.cart.converted_cart_value'),
    isCrossCurrency: !!_.get(state, 'serverData.cart.is_cross_currency'),
    mppInstallmentsTermsUrl: _.get(state, 'serverData.mppInstallmentsTermsUrl', ''),
    isBAWithoutPurchase: _.get(state, 'serverData.isBAWithoutPurchase', false)
});

export default connect(mapStateToProps)(DefaultCTABanner);
